/**
 * Minified by jsDelivr using Terser v3.14.1.
 * Original file: /npm/js-cookie@2.2.1/src/js.cookie.js
 * 
 * Do NOT use SRI with dynamically generated files! More information: https://www.jsdelivr.com/using-sri-with-dynamic-files
 */
!function(e){var n;if("function"==typeof define&&define.amd&&(define(e),n=!0),"object"==typeof exports&&(module.exports=e(),n=!0),!n){var t=window.Cookies,o=window.Cookies=e();o.noConflict=function(){return window.Cookies=t,o}}}(function(){function e(){for(var e=0,n={};e<arguments.length;e++){var t=arguments[e];for(var o in t)n[o]=t[o]}return n}function n(e){return e.replace(/(%[0-9A-Z]{2})+/g,decodeURIComponent)}return function t(o){function r(){}function i(n,t,i){if("undefined"!=typeof document){"number"==typeof(i=e({path:"/"},r.defaults,i)).expires&&(i.expires=new Date(1*new Date+864e5*i.expires)),i.expires=i.expires?i.expires.toUTCString():"";try{var c=JSON.stringify(t);/^[\{\[]/.test(c)&&(t=c)}catch(e){}t=o.write?o.write(t,n):encodeURIComponent(String(t)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,decodeURIComponent),n=encodeURIComponent(String(n)).replace(/%(23|24|26|2B|5E|60|7C)/g,decodeURIComponent).replace(/[\(\)]/g,escape);var f="";for(var u in i)i[u]&&(f+="; "+u,!0!==i[u]&&(f+="="+i[u].split(";")[0]));return document.cookie=n+"="+t+f}}function c(e,t){if("undefined"!=typeof document){for(var r={},i=document.cookie?document.cookie.split("; "):[],c=0;c<i.length;c++){var f=i[c].split("="),u=f.slice(1).join("=");t||'"'!==u.charAt(0)||(u=u.slice(1,-1));try{var a=n(f[0]);if(u=(o.read||o)(u,a)||n(u),t)try{u=JSON.parse(u)}catch(e){}if(r[a]=u,e===a)break}catch(e){}}return e?r[e]:r}}return r.set=i,r.get=function(e){return c(e,!1)},r.getJSON=function(e){return c(e,!0)},r.remove=function(n,t){i(n,"",e(t,{expires:-1}))},r.defaults={},r.withConverter=t,r}(function(){})});
//# sourceMappingURL=/sm/b0ce608ffc029736e9ac80a8dd6a7db2da8e1d45d2dcfc92043deb2214aa30d8.map

var PourMoi = PourMoi || {};
(function($, PourMoi) {
    PourMoi.weather = {
        ipStackApiKey: 'a857cf10f4650411112585bbdb76f60f',
        openWeatherMapApiKey: 'cef1755be2eb9e93c375e169a7062855',
        debug: false,
        
        // Check whether user has previously consented to collecting location information
        checkConsent: function() {
            return Cookies.get('pourmoi_weather_consent');
        },
        // Mark the user as having consented to collecting location information
        setConsent: function() {
            Cookies.set('pourmoi_weather_consent', true, {expires: new Date(new Date().getTime() + 100 * 24 * 60 * 60 * 1000) });
            if('__gaTracker' in window) {
                __gaTracker('send', 'event', 'weather', 'optin');
            }
        },
        // Revoke the user's consent for location data
        revokeConsent: function() {
            Cookies.remove('pourmoi_weather_consent');
            Cookies.remove('pourmoi_weather_data');
            Cookies.remove('pourmoi_weather_product');
            location.reload();
        },
        // Save weather data to a cookie
        // As per GDPR, we aren't saving anything identifiable
        storeWeather: function(temperature, humidity, units, elevation, city) {
            var data = {
                t: temperature,
                h: humidity,
                u: units,
                e: elevation,
                c: city
            };
            Cookies.set('pourmoi_weather_data', JSON.stringify(data), {expires: new Date(new Date().getTime() + 60 * 60 * 1000)});
        },
        // Load weather from the stored data
        loadWeather: function() {
            var data = Cookies.get('pourmoi_weather_data');
            if(data) return JSON.parse(data);
            return false;
        },
        // Try to get the user's location
        getUserLocation: function(el) {
            if('geolocation' in navigator) {
                try {
                    navigator.geolocation.getCurrentPosition(
                        function(pos) {
                            var lat = pos.coords.latitude;
                            var lng = pos.coords.longitude;
			    var latLng = new google.maps.LatLng(lat, lng);
			    var geocoder = new google.maps.Geocoder;
			    
                            // Do a country lookup through Google geocoder
			    geocoder.geocode({ 'location': latLng}, function(results, status) {
				if (status == 'OK') {
				    // Pick the last (least specific) result
                    if(results.length > 2) {
                        if(results[3] != undefined && results[3].address_components[3] != undefined && results[3].address_components[4] != undefined && results[3].address_components[5] != undefined){
                            var city = results[3].address_components[3].long_name +","+results[3].address_components[4].long_name + "," + results[3].address_components[5].long_name
                        }else{
                            var city = results[results.length - 3].formatted_address;
                        }
                    } else {
                        var city = results[results.length - 1].formatted_address;
                    }
                                    // Force units to Imperial regardless of country
                                    units = 'imperial';
                                    
                                    // if(result.address_components[0].short_name == 'US' || result.formatted_address == 'United States') {
                                    //     units = 'imperial';
                                    // } else {
                                    //     units = 'metric';
                                    // }
                                    PourMoi.weather.getUserWeather(el, lat, lng, units, city);
				} else {
				    console.error('geocode error:  ' + status);
				}
			    });
                        },
                        function(err) {
                            console.error('PourMoi.weather.getUserLocation: could not load location data:');
                            console.error(err);
                            PourMoi.weather.getUserLocationByIP(el);
                        }
                    );
                } catch (e) {
                    console.error(e);
                    PourMoi.weather.getUserLocationByIP(el);
                }
            } else {
                PourMoi.weather.getUserLocationByIP(el);
            }
        },
        // Load the user's IP address from the provided element
        getUserIP: function(el) {
            var ip = el.find('input[name="user_ip"]');
            if(ip && ip.val() && ip.val().length) {
                return ip.val();
            }
            return false;
        },
        // Get the user's location based on IP address
        getUserLocationByIP: function(el) {
            var ip;
            if(ip = this.getUserIP(el)) {
                // Locate user by IP address
		$.getJSON('https://api.ipstack.com/'+ip+'?access_key='+PourMoi.weather.ipStackApiKey+'&output=json&legacy=1')
		 .done(function(geoip) {
                     var units;
                     // Force units to Imperial
                     // switch(geoip.country_code) {
                     // case 'US':
                     //     units = 'imperial';
                     //     break;
                     // default:
                     //     units = 'metric';
                     // }
                     units = 'imperial';
                     // console.log('( ' + geoip.latitude + ' , ' + geoip.longitude + ' )');
                     PourMoi.weather.getUserWeather(el, geoip.latitude, geoip.longitude, units, geoip.city + ', ' + geoip.region_name + ', ' + geoip.country_name);		 
                    })
		 .fail(function(jqXHR, textStatus, errorThrown) {
		     console.error('PourMoi.weather.getUserLocation(): Could not load https://api.ipstack.com/'+ip+'?access_key='+PourMoi.weather.ipStackApiKey+'&output=json&legacy=1');
		     PourMoi.weather.displayDefault(el);
		 });
            } else {
                // console.log('Could not load ip');
            }
        },
        // Get the user's weather and elevation
        getUserWeather: function(el, lat = 45.5214068, lon = -122.6524797, units = 'imperial', city = '') {
            if(PourMoi.weather.debug) console.debug('PourMoi.weather.getUserWeather(el, '+lat+', '+lon+' ,\''+units+'\' ,\''+city+'\')')
	    // Start by loading elevation, since it's easier
	    var elevator = new google.maps.ElevationService;
	    var location = new google.maps.LatLng(lat, lon);
	    elevator.getElevationForLocations({
		'locations': [location]
	    }, function(results, status) {
		if (status === 'OK') {
		    if (results[0]) {
			var elevation = results[0].elevation;
            if(PourMoi.weather.debug) console.debug('  Elevation: '+elevation);
			
			// We want to look at the weather from today, from 1000 to 1500 hours
			var now = new Date();
			var from = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 10).getTime() / 1000;
			var to = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 15).getTime() / 1000;
			now = now.getTime() / 1000;
			if(now < to && now > from) {
			    // Pull both forecast and history
                if(PourMoi.weather.debug) console.debug('  Loading weather from forecast and history');
			    $.getJSON('https://api.openweathermap.org/data/2.5/forecast?APPID='+PourMoi.weather.openWeatherMapApiKey+'&units='+units+'&lat='+ lat+'&lon='+lon)
				.done(function(forecast) {
				    $.getJSON('https://history.openweathermap.org/data/2.5/history/city?APPID='+PourMoi.weather.openWeatherMapApiKey+'&units='+units+'&lat='+ lat+'&lon='+lon+'&start='+ from+'&end='+to)
					.done(function(history) {
					    var temperature = 0, humidity = 0, count = 0;
					    for(var i = 0; i < forecast.list.length; i++) {
						if(forecast.list[i].dt >= from && forecast.list[i].dt < to) {
						    temperature += forecast.list[i].main.temp;
						    humidity += forecast.list[i].main.humidity;
						    count ++;
						}
					    }
					    if(history && 'list' in history) {
						for(i = 0; i < history.list.length; i++) {
						    if(history.list[i].dt >= from && history.list[i].dt < to) {
							// All historical temperatures are only provided in Kelvin
							switch(units) {
							    // case 'imperial':
							    //     temperature += ((history.list[i].main.temp - 273) * 1.8 + 32);
							    //     break;
							    // case 'metric':
							    //     temperature += (history.list[i].main.temp - 273);
							    //     break;
							default:
							    temperature += history.list[i].main.temp;
							}
							humidity += history.list[i].main.humidity;
							count ++;
						    }
						}
					    }
					    if(count) {
						temperature /= count;
						humidity /= count;
						PourMoi.weather.storeWeather(temperature, humidity, units, elevation, city);
  					        PourMoi.weather.chooseProduct(el, temperature, humidity, units, elevation, city);
					    } else {
						PourMoi.weather.displayDefault(el);
					    }
					})
					.fail(function(jqXHR, textStatus, errorThrown) {
					    console.error(new Error('PourMoi.weather.getUserWeather(): Could not load https://history.openweathermap.org/data/2.5/history/city?APPID='+PourMoi.weather.openWeatherMapApiKey+'&units='+units+'&lat='+ lat+'&lon='+lon+'&start='+ from+'&end='+to));
					    PourMoi.weather.displayDefault(el);
					});
				})
				.fail(function(jqXHR, textStatus, errorThrown) {
				    console.error(new Error('PourMoi.weather.getUserWeather(): Could not load https://api.openweathermap.org/data/2.5/forecast?APPID='+PourMoi.weather.openWeatherMapApiKey+'&units='+units+'&lat='+ lat+'&lon='+lon));
				    PourMoi.weather.displayDefault(el);
				});
			} else if (now < to) {
                if(PourMoi.weather.debug) console.debug('  Loading weather from forecast');
			    // Pull only forecast
			    $.getJSON('https://api.openweathermap.org/data/2.5/forecast?APPID='+PourMoi.weather.openWeatherMapApiKey+'&units='+units+'&lat='+ lat+'&lon='+lon)
				.done(function(forecast)
				      {
					  var temperature = 0, humidity = 0, count = 0;
					  for(var i = 0; i < forecast.list.length; i++) {
					      if(forecast.list[i].dt >= from && forecast.list[i].dt < to) {
						  temperature += forecast.list[i].main.temp;
						  humidity += forecast.list[i].main.humidity;
						  count ++;
					      }
					  }
					  if(count) {
					      temperature /= count;
					      humidity /= count;
					      PourMoi.weather.storeWeather(temperature, humidity, units, elevation, city);
					      PourMoi.weather.chooseProduct(el, temperature, humidity, units, elevation, city);
					  } else {
					      PourMoi.weather.displayDefault(el);
					  }

				      })
				.fail(function(jqXHR, textStatus, errorThrown) {
				    console.error(new Error('PourMoi.weather.getUserWeather(): Could not load https://api.openweathermap.org/data/2.5/forecast?APPID='+PourMoi.weather.openWeatherMapApiKey+'&units='+units+'&lat='+ lat+'&lon='+lon));
				    PourMoi.weather.displayDefault(el);
				});
			} else if (now > from) {
                if(PourMoi.weather.debug) console.debug('  Loading weather from history');
			    // Pull only history
			    $.getJSON('https://history.openweathermap.org/data/2.5/history/city?APPID='+PourMoi.weather.openWeatherMapApiKey+'&units='+units+'&lat='+ lat+'&lon='+lon+'&start='+ from+'&end='+to)
				.done(function(history) {
				    var temperature = 0, humidity = 0, count = 0;
				    for(var i = 0; i < history.list.length; i++) {
					if(history.list[i].dt >= from && history.list[i].dt < to) {
					    // All historical temperatures are only provided in Kelvin
					    switch(units) {
					        // case 'imperial':
						//     temperature += ((history.list[i].main.temp - 273) * 1.8 + 32);
						//     break;
					        // case 'metric':
						//     temperature += (history.list[i].main.temp - 273);
						//     break;
					    default:
						temperature += history.list[i].main.temp;
					    }
					    humidity += history.list[i].main.humidity;
					    count ++;
					}
				    }
				    if(count) {
					temperature /= count;
					humidity /= count;
					PourMoi.weather.storeWeather(temperature, humidity, units, elevation, city);
					PourMoi.weather.chooseProduct(el, temperature, humidity, units, elevation, city);
				    } else {
					PourMoi.weather.displayDefault(el);
				    }
				})
				.fail(function(jqXHR, textStatus, errorThrown) {
				    console.error(new Error('PourMoi.weather.getUserWeather(): Could not load https://history.openweathermap.org/data/2.5/history/city?APPID='+PourMoi.weather.openWeatherMapApiKey+'&units='+units+'&lat='+ lat+'&lon='+lon+'&start='+ from+'&end='+to));
				    PourMoi.weather.displayDefault(el);
				});
			}

		    } else {
			console.error("Could not load elevation for LatLng("+lat+","+lon+").");
                        PourMoi.weather.displayDefault(el);
		    }
		} else {
		    console.error("Could not load elevation for LatLng("+lat+","+lon+"):  "+status);
                    PourMoi.weather.displayDefault(el);
		}
	    });
	    
        },
        // Display the user's weather on the page
        displayWeather: function(el, temperature, humidity, units, elevation, city='') {
            const arrowIcon = '<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.3333 9L18.3333 13M18.3333 13L14.3333 17M18.3333 13L7.66667 13M25 13C25 19.6274 19.6274 25 13 25C6.37258 25 1 19.6274 1 13C1 6.37258 6.37258 1 13 1C19.6274 1 25 6.37258 25 13Z" stroke="#282727" stroke-linecap="round" stroke-linejoin="round"/></svg>'
            if(el.hasClass('weather-forecast-layout')) {
                el.removeClass('no-product');
                el.find('.headline').html('Treat Your Skin for the Climate You’re In');
                
                el.find('.temp .title').html('Temperature:');
                el.find('.temp .number').html(Math.round(temperature));
                el.find('.temp .units').html('<span>o</span>'+(units == 'imperial' ? 'F' : 'C'));
                
                el.find('.plus').html('+');
                
                el.find('.humidity .title').html('Humidity:');
                el.find('.humidity .number').html(Math.round(humidity));
                el.find('.humidity .units').html('%');
                el.find('.revoke').html('<a onclick="return PourMoi.weather.revokeConsent();"><span>Forget My Location</span>'+arrowIcon+'</a>');
                } else if (el.hasClass('weather-forecast-v2-layout')) {
                el.removeClass('no-weather');
                el.find('.city').html(city);

                el.find('.temperature .w-title').html('Temperature');
                el.find('.temperature .w-number').html(Math.round(temperature));
                el.find('.temperature .w-units').html('<span class="'+units+'"><span>0</span><span>'+(units == 'imperial' ? 'F' : 'C')+'</span>');
                
                el.find('.humidity .w-title').html('Humidity');
                el.find('.humidity .w-number').html(Math.round(humidity));
                el.find('.humidity .w-units').html('%');
		el.find('.elevation .w-title').html('Elevation');
		el.find('.elevation .w-number').html(Math.round((units == 'imperial' ? elevation * 3.28084 : elevation)));
		el.find('.elevation .w-units').html((units == 'imperial' ? 'ft' : 'M'));
        el.find('.revoke').html('<a onclick="return PourMoi.weather.revokeConsent();"><span>Forget My Location</span>'+arrowIcon+'</a>');            }
        },
        // Select a product based on the current weather
        chooseProduct: function(el, temperature, humidity, units, elevation, city) {
            if(PourMoi.weather.debug) {
                console.debug('  Temperature: '+temperature);
                console.debug('  Humidity:    '+humidity);
                console.debug('  Units:       '+units);
                console.debug('  Elevation:   '+elevation);
                console.debug('  City:        '+city);
            }

            var productData = $.parseJSON($('#product-data').text())
            if (productData) {
            for (var i = 0; i < productData.ranges.length; i++) {
                let range = productData.ranges[i];
                if(PourMoi.weather.debug) {
                    console.debug('  Checking:');
                    console.debug(range);
                }
                if (
                (range['t_min'] === null || range['t_min'] < temperature) &&
                (range['t_max'] === null || range['t_max'] >= temperature) &&
                (range['h_min'] === null || range['h_min'] < humidity) &&
                (range['h_max'] === null || range['h_max'] >= humidity) &&
                (range['e_min'] === null || range['e_min'] < elevation) &&
                (range['e_max'] === null || range['e_max'] >= elevation)
                ) {
                    if(PourMoi.weather.debug) console.debug('  Matched: '+range['product']);
                PourMoi.weather.displayProduct(el, productData['products'][range['product']]);
                PourMoi.weather.displayWeather(el, temperature, humidity, units, elevation, city);
                return;
                }
            }
            }
        },
       // Display product information
       displayProduct: function(el, data) {
        let result = data;
        try {
            el.find('.text-wrap-default').removeClass('text-wrap-default').addClass('text-wrap-recommended');
            el.addClass(result['title'].toLowerCase().replace(/ /g,'-'));
            if('description' in data) {
                el.find('.description').html(data['description']);
            }
            if('content' in data) {
                el.find('.headline').html(data['content']+' '+data['title']);
            }
            if('button' in data) {
                let button = data['button'];
                el.find('.buttons').html('<div class="btn-base-wrap"><a class="btn-base" href="'+button.url+'"'+(button.target ? ' target="blank"' : '')+'>'+button.text+'</a></div>');
            }
            if('map_image' in data) {
                el.find('.background').css('background-image', 'url("'+data['map_image']+'")');
            }
            if('background_color' in data) {
                el.find('.info-wrap').css('background-color', data['background_color']);
            }
            if('border_color' in data) {
                el.find('.info-wrap').css('border','1px solid ' + data['border_color']);
            }
            if('text_color' in data) {
                el.find('.info-wrap').css('--custom-color', data['text_color']);
            }
            if('prod_image' in data) {
                el.find('.img-wrap').append("<img class='product_image' src=" + data['prod_image'] + "/>");
            }


        } catch (e) {
            console.error(new Error('PourMoi.weather.displayProduct():  Failed to update element contents.'));
            console.error(e);
            el.remove();
        }
    },
        // Display default product if something goes wrong
        displayDefault: function(el) {
            el.find('.headline').html('Based on your climate, and the long-range weather forecast for your area, we recommend:');
            el.find('.subline').html('');

            var productData = jQuery.parseJSON($('#product-data').text())
            
            if(productData){
              PourMoi.weather.displayProduct(el, productData['products'][productData['ranges'][productData['ranges'].length - 1]['product']]);
              PourMoi.weather.displayWeather(el, temperature, humidity, units, elevation, city);                    
            } else {
              el.remove();
            }
        },
        // General wrapper function
        run: function(el) {
            var weather = PourMoi.weather.loadWeather();
            if(weather) {
                PourMoi.weather.chooseProduct(el, weather.t, weather.h, weather.u, weather.e, weather.c);
            } else {
                PourMoi.weather.getUserLocation(el);
            }
        },
        // Recommend product when button is clicked
        recommendProductFromClick: function(el) {
            PourMoi.weather.setConsent();
            PourMoi.weather.run(jQuery(el).parents().find('.weather-forecast-layout, .weather-forecast-v2-layout'));
            return false;
        },
    };
    // Initialize
    $(function() {
        $.getJSON("https://api.ipify.org?format=json", function(data) {
            $('.weather-forecast-layout, .weather-forecast-v2-layout').each(function() {
                $(this).find('input[name="user_ip"]').val(data.ip);
                // console.log('IP: '+data.ip+'');
                if(PourMoi.weather.checkConsent()) {
                    // console.log('Consent granted from cookie.');
		    if('__gaTracker' in window) {
                        __gaTracker('send', 'event', 'weather', 'reload');
  		    }
                    PourMoi.weather.run($(this));
                }
                $(this).on('PourMoi.weather.loaded', function(event, trigger, el=$(this)) {
                    PourMoi.weather.contentLoad(event, trigger, el);
                });
            });
        });
    });
})(jQuery, PourMoi);
